import { render, staticRenderFns } from "./BasicCalculation.vue?vue&type=template&id=d2d3102e&"
import script from "./BasicCalculation.vue?vue&type=script&lang=js&"
export * from "./BasicCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports